import styled, { css } from 'styled-components';
/**
 * Gets the width of the wrapper given a size.
 *
 * @param {String} size - The size of the wrapper.
 */

var getWrapperWidth = function getWrapperWidth(size) {
  return /^\d+(rem|px)$/.test(size) ? size : 'auto';
};
/**
 * Gets the flex CSS property value of the wrapper given a size.
 *
 * @param {String} size - The flex value.
 */


var getWrapperFlex = function getWrapperFlex(size) {
  return /^\d+$/.test(size) ? size : 'initial';
};

export var Wrapper = styled.div.withConfig({
  displayName: "elements__Wrapper",
  componentId: "cp6xjm-0"
})(["display:flex;flex:", ";width:", ";&:not(:last-child){margin-bottom:", ";margin-right:", ";}"], function (_ref) {
  var size = _ref.size;
  return getWrapperFlex(size);
}, function (_ref2) {
  var size = _ref2.size;
  return getWrapperWidth(size);
}, function (_ref3) {
  var isRow = _ref3.isRow,
      dimensions = _ref3.theme.dimensions;
  return isRow ? 0 : dimensions.small;
}, function (_ref4) {
  var isRow = _ref4.isRow,
      dimensions = _ref4.theme.dimensions;
  return isRow ? dimensions.big : 0;
});
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "cp6xjm-1"
})(["width:100%;display:flex;flex-direction:column;align-items:start;justify-content:flex-end;", ";"], function (_ref5) {
  var inlineLabel = _ref5.inlineLabel;
  return inlineLabel && css(["flex-direction:row;align-items:center;margin-left:0;margin-bottom:", ";"], function (_ref6) {
    var dimensions = _ref6.theme.dimensions;
    return dimensions.small;
  });
});
export var Label = styled.label.withConfig({
  displayName: "elements__Label",
  componentId: "cp6xjm-2"
})(["width:", ";min-height:", ";color:", ";text-align:left;text-transform:uppercase;font-weight:", ";font-size:", ";line-height:", ";margin-top:", ";margin-bottom:", ";margin-left:", ";", ";"], function (_ref7) {
  var width = _ref7.width;
  return width;
}, function (_ref8) {
  var size = _ref8.theme.fonts.size;
  return size.medium;
}, function (_ref9) {
  var palette = _ref9.theme.palette;
  return palette.darkBlue;
}, function (_ref10) {
  var weight = _ref10.theme.fonts.weight;
  return weight.thick;
}, function (_ref11) {
  var size = _ref11.theme.fonts.size;
  return size["default"];
}, function (_ref12) {
  var size = _ref12.theme.fonts.size;
  return size.medium;
}, function (_ref13) {
  var dimensions = _ref13.theme.dimensions;
  return dimensions.small;
}, function (_ref14) {
  var dimensions = _ref14.theme.dimensions;
  return dimensions.small;
}, function (_ref15) {
  var dimensions = _ref15.theme.dimensions;
  return dimensions.tiny;
}, function (_ref16) {
  var inlineLabel = _ref16.inlineLabel;
  return inlineLabel && css(["margin-right:0.5rem;margin-left:0;"]);
});
export var ElementContainer = styled.div.withConfig({
  displayName: "elements__ElementContainer",
  componentId: "cp6xjm-3"
})(["display:flex;flex-direction:column;justify-content:center;width:100%;height:100%;flex:1;"]);
export var ElementWrapper = styled.div.withConfig({
  displayName: "elements__ElementWrapper",
  componentId: "cp6xjm-4"
})(["height:100%;"]);